import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { FileOption } from '../../prompt-details/models/file.option.interface';
import { CallLogsFilterOptions } from '../models/call-logs-filter-option';
import { CallLogsRegisterListItem } from '../models/call-logs-register-results.model';

const area = 'CallLogs Register';
export const callLogsRegisterAdapterActions = createRegisterActions<CallLogsRegisterListItem>(area);

export const createCallLogs = createAction(`[${area}] Create CallLogs`);

export const openDialog = createAction('[Call Logs] Open Dialog', props<{ callLogs: CallLogsRegisterListItem }>());

export const listenToRecording = createAction(
   '[Call Logs] Listen to recording',
   props<{ callRecording: ListenToRecordingModel }>()
);

export const callLogsRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: CallLogsFilterOptions[]; quickFilters: any }>()
);

export const deleteCallRecording = createAction(
   `[${area}] Delete Call Recording`,
   props<{ callRecordingId: number }>()
);

export const deleteCallRecordingSuccess = createAction(
   `[${area}] Delete Call Recording Success`,
   props<{ callRecordingId: number }>()
);

export const deleteCallRecordingFailure = createAction(
   `[${area}] Delete Call Recording Failure`,
   props<SingleGraphError>()
);

export interface ListenToRecordingModel {
   files: FileOption[];
   callRecordingId: number | null;
}
